module.exports = __webpack_public_path__ + "img/neckline length.7b8985f2.png";